import { arrInc } from '../../../fun-js-lib/arr'
import Rect from '../../../fun-js-lib/geometry/Rect'
import { drawDiagonal, fillStyled, fillTextStyled, textWidth } from '../../canvasDraw'
import { textCentered } from '../drawUtils'
import { mainFrameRect } from '../rects'
import { smallPadding, textPadding } from '../sizes'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 * @param {import('../../constructionLog').LogPage} page
 */
export function textWorkingTime (context, linesColor, page) {
  let frame = mainFrameRect()
  let x = frame.x + smallPadding
  let y = frame.y + 250
  fillTextStyled(context, 'РАДНО ВРЕМЕ', x, y + 80, linesColor)

  y = frame.y + 420
  let lineInterval = 70
  fillTextStyled(context, 'I смена од', x + 18, y, linesColor)
  fillTextStyled(context, 'II смена од', x + 9, y + lineInterval, linesColor)
  fillTextStyled(context, 'III смена од', x, y + lineInterval * 2, linesColor)

  let line1W = 100
  arrInc(3).forEach(i => {
    x = frame.x + smallPadding + textWidth(context, 'III смена од') + textPadding
    let rect1 = Rect.plain({
      x,
      y: y - 30 + i * lineInterval,
      w: line1W,
      h: 30
    })
    textCenteredOrDiagonal(context, page.shifts[i].start_time, rect1)
    fillStyled(context, linesColor, () => {
      context.fillRect(x, y + i * lineInterval, line1W, 1)
    })
    x += line1W + textPadding
    fillTextStyled(context, 'до', x, y + i * lineInterval, linesColor)

    let line2W = 125
    x += textWidth(context, 'до') + textPadding
    let rect2 = Rect.plain({
      x,
      y: y - 30 + i * lineInterval,
      w: line2W,
      h: 30
    })
    textCenteredOrDiagonal(context, page.shifts[i].end_time, rect2)
    fillStyled(context, linesColor, () => {
      context.fillRect(x, y + i * lineInterval, line2W, 1)
    })

    x += line2W + textPadding
    fillTextStyled(context, 'укупно', x, y + i * lineInterval, linesColor)

    let line3W = line2W
    x += textWidth(context, 'укупно') + textPadding
    fillStyled(context, linesColor, () => {
      context.fillRect(x, y + i * lineInterval, line3W, 1)
    })
    let rect3 = Rect.plain({
      x,
      y: y - 30 + i * lineInterval,
      w: line3W,
      h: 30
    })
    textCenteredOrDiagonal(context, '' + page.shifts[i].total_time, rect3)

    x += line3W + textPadding
    fillTextStyled(context, 'часова', x, y + i * lineInterval, linesColor)
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} text 
 * @param {Rect} rect
 */
function textCenteredOrDiagonal (context, text, rect) {
  if (text === '') {
    drawDiagonal(context, rect)
  } else {
    let y = rect.y + rect.h - 1
    textCentered(context, text, rect.x, y, rect.w)
  }
}